import { Close } from '@mui/icons-material';
import { ACTION_STATUS } from '~/components/Admin/ResourceTable';
import { admin } from '~/components/Admin/AdminDialog/AdminDialog.style';

type TProps = {
  open: boolean;
  status: ACTION_STATUS;
  titleText: string;
  children: React.ReactNode;
  handleClose: () => void;
};

export const AdminDialog = ({
  open,
  status,
  titleText,
  children,
  handleClose,
}: TProps) => {
  return (
    <admin.Dialog open={open} onClose={handleClose} status={status}>
      <>
        <admin.DialogTitle>
          {titleText}
          <Close onClick={handleClose} sx={{ cursor: 'pointer' }} />
        </admin.DialogTitle>
        {children}
      </>
    </admin.Dialog>
  );
};
